import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { interactiveState } from '../../util/interactiveState.js';
import { Box } from '../Box/Box.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { LinkStyled } from './Link.styled.js';

var _excluded = ["children", "href", "rel", "target", "disabled", "interactive", "display", "width", "height"];
/**
 * The Link component allows you to create hyperlink on top of any component. Consider using [TextLink](?path=/docs/components-textlink--docs) if you want to create text with hyperlink.
 */
var Link = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    href = _ref.href,
    rel = _ref.rel,
    target = _ref.target,
    disabled = _ref.disabled,
    interactive = _ref.interactive,
    display = _ref.display,
    width = _ref.width,
    height = _ref.height,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useThemeContext();
  if (href) {
    var interactiveStateStyle = interactive && interactiveState(theme, interactive);
    return /*#__PURE__*/React.createElement(LinkStyled, _extends({}, rest, {
      role: "link",
      "aria-disabled": disabled,
      href: !disabled ? href : undefined,
      rel: rel,
      target: target,
      $display: display,
      $width: width,
      $height: height,
      $interactiveStyle: interactiveStateStyle,
      $outlineStyle: "none",
      ref: ref
    }), children);
  }
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    as: "button",
    p: "0",
    cursor: disabled ? undefined : 'pointer',
    disabled: disabled,
    display: display,
    width: width,
    height: height,
    textAlign: "start",
    interactive: interactive,
    outlineStyle: "none",
    ref: ref
  }), children);
});
var LinkMemoized = /*#__PURE__*/React.memo(Link);
LinkMemoized.displayName = 'Link';

export { Link as BaseLink, LinkMemoized as Link };
//# sourceMappingURL=Link.js.map
